import EditIcon from 'assets/editIcon.svg'
import { EditBtnContainer } from './styles'

export function EditButton(props: any){
    return (
        <EditBtnContainer>
            <button className={props.className} type="button" onClick={props.onClick}><img className="buttonImg" src={EditIcon} alt="Editar"/></button>
        </EditBtnContainer>
    )
}